import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import { Tween } from "../../../vendor_core/core/src/Tween";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import GameSoundVars from "../enums/GameSoundVars";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import App from "../../../vendor_core/core/src/App";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import Locale from "../../../vendor_core/core/src/utils/Locale";
import KeyboardManager from "../../../vendor_core/core/src/utils/KeyboardManager";
import { FadeIn, FadeOut } from "../../../vendor_core/core/src/transitions/TransitionAnimations";
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import CoinModel from '../../model/CoinModel';
import { State } from "../../../vendor_core/core/src/states/State";
import { GameHowl } from "../../../vendor_core/core/src/utils/GameHowl";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import DoubleChanceModel from "../../model/DoubleChanceModel";

export default class TRWExitFreespinsState extends State {
    private isSceneClosed = false;
    protected winMusic: GameHowl | undefined;

    public enter(): void {
        CommandManager.execute(Commands.UPDATE_FREE_SPINS, SpinModel.freespinWinnings);

        Tween.delayedCall(2, () => {
            this.showPopup();
        }, [], this);

        super.enter();
        ViewManager.getLayer("FreespinCounter").clear();
        ViewManager.getLayer("ThumbleWinCounter").clear();
        this.isSceneClosed = false;
    }

    public showPopup(): void {
        App.dispatcher.emit(GameEvents.SHOW_FREE_SPIN_OUTRO);
        SoundController.playSound(`${GameSoundVars.FREE_SPINS_COMPLETED}_${SpinModel.featureMode - 1}`);

        ViewManager.getLayer("SplashOverlay").setScene("open");
        //  this.winMusic = SoundController.playSound(GameSoundVars.FREESPINS_END_POPUP,false,null,false);
        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("freespinssummary");
        CommandManager.execute(Commands.UPDATE_FREE_SPINS);
        scene.interactive = true;

        const transitionDuration = 0.3;

        let outroEffect = scene.spineAnimations.get("fsIntroOutro");

        const fsWin = scene.sceneTextFields.get("fsWin") as TextField;
        fsWin.alpha = 0;

        let headerTxt = scene.sceneTextFields.get("header");
        headerTxt.alpha = 0;
        let title2 = scene.sceneTextFields.get("title2");
        title2.alpha = 0;
        const hasWin = SpinModel.accumulatedWin > 0;
        headerTxt.text = Locale.getString(hasWin ? "fs_summary_header" : "exit_free_games_title");
        title2.text = Locale.getString(hasWin ? "gui_exit_free_games_data" : "gui_exit_free_games_data_loss");

        let winMoney = scene.sceneMoneyFields.get("win_counter");
        winMoney.value = SpinModel.accumulatedWin;
        winMoney.alpha = 0;

        let winSpins = scene.sceneTextFields.get("win_spins");
        winSpins.alpha = 0;

        const obj = headerTxt.children[0];
        obj.scale.set(0, 0);

        Tween.delayedCall(transitionDuration, () => {
            // outroEffect.playAsync("start_outro").then(() => outroEffect.playAsync("loop_outro"));
            SoundController.playSound("introTransition");
            Layout.isLandscape() ? outroEffect.playChainingAnim("outro") : outroEffect.playChainingAnim("outro_pt");
            FadeIn(headerTxt, 0.5);
            FadeIn(title2, 0.5);
            if (hasWin) {
                FadeIn(winMoney, 0.5);
            }

            Tween.fromTo(obj.scale, 1,
                {
                    x: 0.9,
                    y: 0.9,
                },
                {
                    x: 1,
                    y: 1,
                    yoyo: true,
                    repeat: -1,
                }
            );
        });

        Tween.delayedCall(2, () => {
            scene.once(PointerEvents.DOWN, () => {
                App.dispatcher.emit(GameEvents.FREE_SPIN_OUTRO_CLOSED);
                Tween.delayedCall(transitionDuration, () => {
                    FadeOut(headerTxt, 0.3);
                    FadeOut(title2, 0.3);
                    if (hasWin) {
                        FadeOut(winMoney, 0.3);
                    }
                    SoundController.playSound("transitionEnd");
                    outroEffect.playAsync("outro_end")
                        .then(() => {
                            CoinModel.stopAnticipation();
                            this.closePopup(scene);
                        });
                });
            })
        });


    }

    public closePopup(scene: SceneView): void {
        if (!this.isSceneClosed) {

            KeyboardManager.enable();
            this.isSceneClosed = true;

            let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
                .getCurrentScene()
                .getSubView("ReelGroup") as ReelGroup;
            reelGroup.winSymbolsView.unlockAll();
            reelGroup.winSymbolsView.stopAll();
            reelGroup.hideLinesAndInfo(true);
            ViewManager.getLayer(DefaultLayers.Popups).clear();

            if (SpinModel.featureMode == 2) {
                ViewManager.getLayer("Multipliers").clear();
            }
            // BackgroundHelper.backgroundLoop();

            ViewManager.getLayer("SplashOverlay").clear();
            SpinModel.exitFreespins();

            if (this.winMusic) {
                SoundController.stopSound(this.winMusic);
            }

            SpinModel.featureMode = -1;
            reelGroup.revealAllSymbols();
            scene.destroy();
            this.playFrameAnim();
            this.playBGAnim();
            this.exit();
        }
    }

    private playFrameAnim(): void {
        const frScene = ViewManager.getLayer(DefaultLayers.ReelsFront).getCurrentScene();
        const anim = frScene?.spineAnimations?.get("frame_anticipation");
        if (anim) {
            DoubleChanceModel.isActivated ? anim.play("loop_db") : anim.play("loop_mg");
        }
    }

    private playBGAnim(): void {
        const frScene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
        const anim = frScene?.spineAnimations?.get("animation");
        if (anim) {
            anim.play("mg_loop");
        }
    }

}
